import { useCallback, useState } from 'react';
import apiService from '../../../api/apiService';
import { submitRecipeComment } from '../use-cases/addCommentForm';

interface UseAddCommentFormOptions {
  recipeId: string;
  authorId: number | null | undefined;
  token: string | null;
}

interface UseAddCommentFormResult {
  comment: string;
  submitting: boolean;
  error: string;
  setComment: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: (event: React.FormEvent) => Promise<void>;
}

export const useAddCommentForm = ({
  recipeId,
  authorId,
  token,
}: UseAddCommentFormOptions): UseAddCommentFormResult => {
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = useCallback(async (event: React.FormEvent) => {
    event.preventDefault();

    setSubmitting(true);
    setError('');

    try {
      const result = await submitRecipeComment({
        recipeId,
        authorId,
        token,
        comment,
        addComment: apiService.addComment,
      });

      if (result.error) {
        setError(result.error);
      }
      if (result.shouldResetComment) {
        setComment('');
      }
    } finally {
      setSubmitting(false);
    }
  }, [authorId, comment, recipeId, token]);

  return {
    comment,
    submitting,
    error,
    setComment,
    handleSubmit,
  };
};

export default useAddCommentForm;
